import React, { useState, useEffect, useCallback, useRef } from "react";
import Menu from "../../../../components/layout/menu/index";
import FilterInput from "../../../../components/filters/filterInput";
import '../../../../../src/index.css'
import ModalSuccess from "../../../../components/shared/modals/modalSuccess";
import BillingFilters from "../../../../components/filters/billingFilters";
import DynamicTable from "../../../../components/tables/oc/provider/dynamicTable";
import { getTableConfig } from "../../../../components/tables/billing/tableColumns";
import { useModuleAdherence } from "../../../../hooks/userAdherence";
import { useAuth } from "../../../../context/auth";
import ResetFilters from "../../../../components/filters/resetFilters";
import BillingObs from "../../../../components/shared/modals/billingObs";
import { getListFacturation, observeFacturation, getObserveFacts, markMultipleAsViewed, updateObservation } from "../../../../client/facturation";
import { UpdatePdfOC } from "../../../../client/purchaseOrder";
import PdfViewerModal from "../../../../components/pdfViewer";
import ModalAlertWarning from "../../../../components/shared/modals/modalAlertWarning";

const statusColors = {
    'Nota de crédito': '#E44949',
    'Pendiente de facturación': '#FFB81C',
    'Facturado': '#00A3E0',
    'Observado': '#E44949'
};

const statusMapping = {
    'Pendientes de facturación': [10],
    'Pendientes de nota de crédito': [11],
    'Observaciones': [9],
    'Todas': null
};

<style>
{`
.table-simplebar .simplebar-scrollbar {
background: #007696;
border-radius: 20px;
width: 5px;
}

.table-simplebar .simplebar-scrollbar:before {
background: #007696 !important;
}
`}
</style>

const formatDecimal = (value) => {
  if (value === null || value === undefined) return '';
  const num = parseFloat(value);
  if (isNaN(num)) return '';
      
  return num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

export default function BillingProvider() {
  useModuleAdherence(10);
  const { supplierId} = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const [activeTab, setActiveTab] = useState('Todas');
  const tabs = ['Todas', 'Pendientes de facturación', 'Pendientes de nota de crédito', 'Observaciones'];

  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

  const [resetFiltersFlag, setResetFiltersFlag] = useState(false);
  const [isTabChanging, setIsTabChanging] = useState(false);

  const [tableData, setTableData] = useState([]);

  const [isCorrectionModalOpen, setIsCorrectionModalOpen] = useState(false);
  
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  
  const [selectedFacturationId, setSelectedFacturationId] = useState(null);
  const [isUpdateObservation, setIsUpdateObservation] = useState(false);

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
const [observationsCount, setObservationsCount] = useState(0);
  const [unviewedObservationIds, setUnviewedObservationIds] = useState([]);
  const [markingAsViewed, setMarkingAsViewed] = useState(false);
  const observationTimerRef = useRef(null);
  const [showAlertWarning, setShowAlertWarning] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  
  const [tempFilters, setTempFilters] = useState({
    emissionDateFrom: '',
    emissionDateTo: '',
    statusIds: null
  });

  const [activeFilters, setActiveFilters] = useState({
    emissionDateFrom: '',
    emissionDateTo: '',
    statusIds: null
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500); 

    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => {
    setCurrentPage(1);
  }, [debouncedSearchTerm]);

  const fetchUnviewedObservationIds = useCallback(async () => {
    try {
      const response = await getObserveFacts();
      if (response.data && response.data.facturationIds) {
        setUnviewedObservationIds(response.data.facturationIds);
      }
    } catch (error) {
      console.error('Error al obtener IDs no visualizados:', error);
    }
  }, []);


  
useEffect(() => {
  if (activeTab === 'Observaciones') {
    fetchUnviewedObservationIds();
  }
}, [activeTab, fetchUnviewedObservationIds]);

useEffect(() => {
  if (showSuccessModal && modalMessage === 'Observación enviada correctamente!') {
    fetchUnviewedObservationIds();
    loadTableData();
  }
}, [showSuccessModal, modalMessage, fetchUnviewedObservationIds]);

const markObservationsAsViewed = useCallback(async () => {
  if (unviewedObservationIds.length === 0) return;

  setMarkingAsViewed(true);
  
  try {
    const response = await markMultipleAsViewed(unviewedObservationIds);
    
    if (response.status === 200) {
      
      setUnviewedObservationIds([]);
      
      setObservationsCount(prev => Math.max(0, prev - response.data.updatedCount));
      
      setTableData(prevData => 
        prevData.map(item => ({
          ...item,
          isViewed: unviewedObservationIds.includes(item.originalId) ? true : item.isViewed
        }))
      );

    }
  } catch (error) {
    console.error('Error al marcar como visualizado:', error);
  } finally {
    setMarkingAsViewed(false);
  }
}, [unviewedObservationIds]);

  useEffect(() => {
    fetchUnviewedObservationIds();
  }, [fetchUnviewedObservationIds]);

useEffect(() => {
  if (observationTimerRef.current) {
    clearTimeout(observationTimerRef.current);
  }

  if (activeTab === 'Observaciones' && unviewedObservationIds.length > 0) {
    
    observationTimerRef.current = setTimeout(() => {
      markObservationsAsViewed();
    }, 3000);
  }

  return () => {
    if (observationTimerRef.current) {
      clearTimeout(observationTimerRef.current);
    }
  };
}, [activeTab, unviewedObservationIds, markObservationsAsViewed]);


  useEffect(() => {
    return () => {
      if (observationTimerRef.current) {
        clearTimeout(observationTimerRef.current);
      }
    };
  }, []);

  const loadTableData = async () => {
    if (!supplierId) return;
    
    setIsTabChanging(true);
    setLoading(true);

    try {
      const supplierIds = [parseInt(supplierId)];

      let statusIdsToSend = null;
      
      if (activeTab === 'Todas') {
        statusIdsToSend = activeFilters.statusIds;
      } else {
        statusIdsToSend = statusMapping[activeTab];
      }

      const emissionDateFrom = activeFilters.emissionDateFrom || undefined;
      const emissionDateTo = activeFilters.emissionDateTo || undefined;

      const response = await getListFacturation(
        {
          emissionDateFrom: emissionDateFrom,
          emissionDateTo: emissionDateTo,
          statusIds: statusIdsToSend
        },
        debouncedSearchTerm,
        currentPage,
        recordsPerPage,
        supplierIds
      );

      if (response.data && response.data.data) {
        const transformedData = response.data.data.map((item, index) => 
          transformApiData(item, activeTab, index)
        );
        setTableData(transformedData);
        setTotalRecords(response.data.totalCount || 0);
        setTotalPages(Math.ceil((response.data.totalCount || 0) / recordsPerPage));
        
        if (response.data.newObservationsCount !== undefined) {
          setObservationsCount(response.data.newObservationsCount);
        }

      }
    } catch (error) {
      console.error('Error al cargar datos de facturación:', error);
    } finally {
      setIsTabChanging(false);
      setLoading(false);
    }
  };

  const transformApiData = (apiItem, tab, index) => {
    const baseData = {
      id: index + 1 + ((currentPage - 1) * recordsPerPage),
      originalId: apiItem.id,
      numeroOC: apiItem.purchaseOrder?.order_number,
      pos: apiItem.position?.number,
      pedido: apiItem.purchaseOrderPosition?.description || ' ',
      cantPedida: apiItem.purchaseOrderPosition?.cant || '-',
      un: apiItem.purchaseOrderPosition?.unit_weight,
     // cantFacturada: 0, 
      diasNoFacturados: apiItem.purchaseOrderPosition?.remaining_days,
      fechaEmision: apiItem.purchaseOrder?.emission_date || '',
      fechaEntrega: apiItem.purchaseOrderPosition?.delivery_Date || '',
      precio: formatDecimal(apiItem.purchaseOrderPosition?.net_amount),
      montoOC: formatDecimal(apiItem.purchaseOrderPosition.em_dollarized),
      montoFacturado: formatDecimal(apiItem.purchaseOrderPosition.fact_dollarized),
      comentarios: apiItem.observation || null,
      cant: apiItem.purchaseOrderPosition?.cant || '-',
      moneda: apiItem.purchaseOrderPosition?.coin || '',
      fechaEntregaReal: apiItem.purchaseOrderPosition?.delivery_Date || '',
      fechaEntregaContable: apiItem.purchaseOrderPosition?.delivery_to_warehouse_Date || '',
      estado: getStatusName(apiItem.status),
      comprador: apiItem.purchaseOrder?.user_code,
      detalles: () => handleViewDetails(apiItem.purchaseOrder.id),
      agregarOb: () => handleOpenAddObservation(apiItem.id),
      corregir: () => handleOpenCorrection(apiItem.id),
      montoPendFact: formatDecimal(apiItem.purchaseOrderPosition?.pending_to_invoice) || '',

      isViewed: apiItem.isViewed
    };

    baseData.ir = () => window.open('https://proveedores.centria.net/', '_blank');

    return baseData;
  };

  const getStatusName = (status) => {
    if (!status) return 'Desconocido';
    const statusMap = {
      9: 'Observado',
      10: 'Pendiente de facturación',
      11: 'Nota de crédito'
    };
    return statusMap[status.id] || status.name || 'Desconocido';
  };

  useEffect(() => {
    loadTableData();
  }, [activeTab, currentPage, recordsPerPage, activeFilters, debouncedSearchTerm, supplierId]);

  useEffect(() => {
    setCurrentPage(1);
  }, [activeTab, activeFilters]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);  
    if (tab !== 'Todas') {
      setActiveFilters(prev => ({
        ...prev,
        statusIds: null 
      }));
    }
  };

  const handleRecordsCountChange = (e) => {
    const newCount = Number(e.target.value);
    setRecordsPerPage(newCount);
    setCurrentPage(1);
  };

  const changePage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

const handleViewDetails = async (purchaseOrderId) => {
  try {
    const response = await UpdatePdfOC(purchaseOrderId);
    
    if (response.data.pdfUrl) {
      setPdfUrl(response.data.pdfUrl);
      setShowPdfModal(true);
    } else if (response.data.message === "La orden de compra ya tiene un PDF asociado.") {
      setPdfUrl(response.data.pdfUrl);
      setShowPdfModal(true);
    } else {
      console.error("No se pudo obtener el PDF:", response.data.message);
    }
  } catch (error) {
    console.error("Error al actualizar el PDF:", error);
    
    if (error.response?.status === 404 && error.response?.data?.message) {
      setAlertMessage(error.response.data.message);
      setShowAlertWarning(true);
    } else if (error.response?.status === 400 && error.response?.data?.message) {
      setAlertMessage(error.response.data.message);
      setShowAlertWarning(true);
    } else {
      setAlertMessage("Error al cargar el PDF. Por favor intente nuevamente.");
      setShowAlertWarning(true);
    }
  }
};

  const handleResetFilters = () => {
    setResetFiltersFlag(prev => !prev);
    setSearchTerm('');
    setCurrentPage(1);
    setActiveFilters({
      emissionDateFrom: '',
      emissionDateTo: '',
      statusIds: null 
    });
  };

  const applyFilters = (filters) => {
    if (filters) {
      const filtersWithDefaults = {
        emissionDateFrom: filters.emissionDateFrom || '',
        emissionDateTo: filters.emissionDateTo || '',
        statusIds: filters.statusIds || null
      };
      setActiveFilters(filtersWithDefaults);
    } else {
      setActiveFilters({ ...tempFilters });
    }
    setCurrentPage(1);
  };

  const paginatedData = tableData;

  const handleOpenCorrection = (facturationId, ocNumber) => {
    setSelectedFacturationId(facturationId);
    setIsUpdateObservation(true); 
    setIsCorrectionModalOpen(true);
  };

const handleOpenAddObservation = (facturationId) => {
  setSelectedFacturationId(facturationId);
  setIsUpdateObservation(false); 
  setIsCorrectionModalOpen(true);
};


const handleSubmitObservation = async (observationText) => {
  if (!selectedFacturationId) return;

  try {
    setLoading(true);
    
    let response;
    if (isUpdateObservation) {
      response = await updateObservation(selectedFacturationId, observationText);
    } else {
      response = await observeFacturation(selectedFacturationId, observationText);
    }
    
    if (response.status === 200) {
      await loadTableData();
      
      const successMessage = isUpdateObservation 
        ? 'Observación corregida correctamente!' 
        : 'Observación enviada correctamente!';
      
      setModalMessage(successMessage);
      setShowSuccessModal(true);

      await fetchUnviewedObservationIds();
    }
  } catch (error) {
    console.error('Error al procesar la observación:', error);
    
    let errorMessage = 'Error al procesar la observación';
    
    if (error.response?.status === 404) {
      errorMessage = 'Factura no encontrada';
    } else if (error.response?.status === 500) {
      errorMessage = 'Error del servidor al procesar la observación';
    } else if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    }
    
    setModalMessage(errorMessage);
    setShowWarningModal(true);
  } finally {
    setLoading(false);
    handleCloseObservationModal();
  }
};
const handleCloseObservationModal = () => {
  setIsCorrectionModalOpen(false);
  setSelectedFacturationId(null);
  setIsUpdateObservation(false);
};
  
  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    setModalMessage('');
  };

  return (
    <>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"}  bg-[#F7F8F9] w-full z-50 min-h-screen`}>
      {showPdfModal && (
        <PdfViewerModal 
          pdfFile={pdfUrl} 
          onClose={() => {
            setShowPdfModal(false);
            setPdfUrl(null);
          }} 
        />
      )}
        <div className="pt-4 md:pt-8 pb-10 px-[3%]">
          <div className="flex flex-col justify-between w-full gap-2 pb-6 items-left sm:items-center lg:flex-row">
            <h1 className="text-2xl md:text-[32px] text-blue font-itcbold">
              Facturación
            </h1>
            <div className="flex flex-col items-center justify-between gap-3 sm:flex-row sm:gap-3">
              <div className="flex items-end md:items-center">
                <FilterInput
                  title="Buscar"
                  placeholder="Escriba número de OC"
                  value={searchTerm}
                  onChange={(e) => {
                      const inputValue = e.target.value;
                      if (inputValue === '' || /^[0-9]*$/.test(inputValue)) {
                          setSearchTerm(inputValue);
                      }
                  }}
                  classname="w-[180px]"
                />
              </div>
              
              <div className="flex items-center gap-3">
                <BillingFilters 
                  applyFilters={applyFilters}
                  activeFilters={activeFilters}
                  resetFlag={resetFiltersFlag}
                  activeTab={activeTab} 
                />
                <ResetFilters
                  borderColor="border-blue-light"
                  textColor="text-[#6B7280]"
                  font="font-itcbook"
                  onClick={handleResetFilters}
                />
              </div>
            </div>
          </div>
          
          <div className="flex flex-col items-end justify-between gap-4 md:items-center lg:flex-row ">
            <div className="flex flex-col w-full overflow-x-auto scrollbar-hide"> 
              <nav className="flex "> 
                {tabs.map((tab) => (
                  <button
                    key={tab}
                    className={`px-5 p-2 border-b-[3px] border-blue max-w-[230px] h-[64px]  font-itcmedium rounded-t-xl flex items-center justify-between gap-2  
                      ${activeTab === tab ? 'text-white bg-blue cursor-default' : 'text-blue bg-white cursor-pointer'}`}
                    onClick={() => handleTabChange(tab)}
                    disabled={activeTab === tab}
                  >
                    <p className="text-sm md:text-lg font-itcmedium">{tab}</p>
                     
                    
                    {tab === 'Observaciones'  && observationsCount > 0 && (
                      <div className="p-1 text-sm px-[9px] inline-block text-white rounded-full font-itcbold  bg-red-dark">
                         {observationsCount}
                      </div>
                    )}
                    
                  </button>
                ))}
              </nav>
            </div>
          </div>
          <div>
            <div className="flex flex-col-reverse items-start justify-between gap-3 my-4 md:items-center md:flex-row">
              <div className="flex items-center space-x-2 text-sm font-itcbook">
                <p >Mostrar</p>
                <div className="border-[#D1D5DB] border-[1px] rounded-md w-[58px] flex justify-center items-center h-[40px]">
                  <select
                    className="w-full h-full px-2 text-sm bg-white rounded-md outline-none font-itcbook"
                    value={recordsPerPage}
                    onChange={handleRecordsCountChange}  
                  >
                    <option value={10}>10</option>
                    <option value={15}>15</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                  </select>
                </div>
                <p >Registros</p>
              </div>      
            </div>
            <DynamicTable 
              data={paginatedData} 
              config={getTableConfig(activeTab)} 
              currentPage={currentPage}
              totalPages={totalPages}
              changePage={changePage}
              recordsPerPage={recordsPerPage}
              totalRecords={totalRecords}
              statusColors={statusColors}
              loading={loading || isTabChanging}
              isOCProvider={activeTab !== 'Todas'}
              activeTab={activeTab}
            />
          </div>
        </div>
      </div>
      <BillingObs
        isOpen={isCorrectionModalOpen}
        onClose={handleCloseObservationModal}
        onSubmit={handleSubmitObservation}
        title={isUpdateObservation ? "Corregir observación" : "Agregar observación"}
      />

       <ModalSuccess
          showModalSuccess={showSuccessModal}
          closeModalSuccess={handleCloseSuccessModal}
          text={modalMessage}
          fill="green"
        />

        <ModalAlertWarning
          showModalAlertWarning={showAlertWarning}
          closeModal={() => setShowAlertWarning(false)}
          error={alertMessage}
          accept={() => setShowAlertWarning(false)}
        />
    </>
  );
}